
export enum MoreButtonType {

    CONTROL_BUTTON_S24  = 'control-button-s24',
    CONTROL_BUTTON_S28  = 'control-button-s28', // i.e. project top more button

    ICON_ONLY           = 'ui5', // icon-only-s24

    TASK_VIEW           = 'task-view',
}